import script from "./Root.vue?vue&type=script&lang=ts&setup=true"
export * from "./Root.vue?vue&type=script&lang=ts&setup=true"

import "./Root.vue?vue&type=style&index=0&id=2791d7d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2791d7d8"]])

export default __exports__